import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, Divider, useTheme } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const LoginTimeWidget = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [timeData, setTimeData] = useState({ time: '', ampm: '', date: '' });

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      
      // Time Format (06:25)
      let hours = now.getHours();
      let minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      hours = hours < 10 ? `0${hours}` : hours;

      // Date Format (Monday, 08 June)
      const options = { weekday: 'long', day: '2-digit', month: 'long' };
      const dateStr = now.toLocaleDateString('en-US', options);

      setTimeData({
        time: `${hours}:${minutes}`,
        ampm,
        date: dateStr
      });
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ px: 2,py:0,display:'flex',justifyContent:'center' }}>
      <Card
  sx={{
    background: isDark ? 'rgba(15, 23, 42, 0.02)' : 'rgba(15, 23, 42, 0.02)',
    backdropFilter: 'blur(16px)',
    border: "1px solid rgba(0, 0, 0, 0.06)",
    borderRadius: '20px',
    padding: '14px 16px',
    textAlign: 'center',
    width: 200,
    boxShadow: isDark ? '0 16px 32px rgba(0,0,0,0.04)' : '0 16px 32px rgba(0,0,0,0.04)',
  }}
>  <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#8f01ff', mt: 1, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
    {timeData.date}
  </Typography>
  <Box display="flex" alignItems="baseline" justifyContent="center">

    <Typography variant="h3" sx={{ fontWeight: 600, letterSpacing: '-1.5px', color:'#0f172a' }}>
      {timeData.time}
    </Typography>
    <Typography variant="caption" sx={{ fontWeight: 700, ml: 0.5, color: "#0f172a", letterSpacing: 1 }}>
      {timeData.ampm}
    </Typography>
  </Box>

</Card>
    </Box>
  );
};

export default LoginTimeWidget;